export const errorMessage = {
  color: 'white',
  fontWeight: '100',
  marginBottom: '1rem',
}
